import React from 'react';

const F = "'Inter', system-ui, sans-serif";

const OPERATOR_NAME  = 'Vorname Nachname';   // ← AUSFÜLLEN (wie im Impressum)
const OPERATOR_STREET = 'Straße Hausnummer'; // ← AUSFÜLLEN
const OPERATOR_ZIP   = '6XXX Musterort';     // ← AUSFÜLLEN
const OPERATOR_EMAIL = 'lechcamping@tnr.at';

export default function Datenschutz() {
  return (
    <main style={styles.page}>
      <div style={styles.pageHeader}>
        <div style={styles.pageHeaderInner}>
          <span style={styles.eyebrow}>Rechtliches</span>
          <h1 style={styles.heading}>Datenschutzerklärung</h1>
          <p style={styles.sub}>Gemäß DSGVO und österreichischem Datenschutzgesetz (DSG)</p>
        </div>
      </div>

      <div style={styles.inner}>

        <Block title="1. Verantwortlicher">
          <p>
            Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br />
            <strong>{OPERATOR_NAME}</strong><br />
            {OPERATOR_STREET}, {OPERATOR_ZIP}, Österreich<br />
            E-Mail: <a href={`mailto:${OPERATOR_EMAIL}`} style={styles.link}>{OPERATOR_EMAIL}</a>
          </p>
        </Block>

        <Block title="2. Allgemeines zur Datenverarbeitung">
          <P>
            Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies
            zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
            erforderlich ist. Die Verarbeitung erfolgt nur auf Grundlage einer gesetzlichen Erlaubnis
            (Art. 6 DSGVO).
          </P>
        </Block>

        <Block title="3. Server-Logfiles">
          <P>
            Beim Aufruf unserer Website werden durch den Webhoster automatisch Informationen in
            sogenannten Server-Logfiles gespeichert:
          </P>
          <ul style={styles.list}>
            <li>IP-Adresse des anfragenden Rechners</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Name und URL der abgerufenen Datei</li>
            <li>Übertragene Datenmenge, Zugriffsstatus (HTTP-Statuscode)</li>
            <li>Browsertyp und -version, Betriebssystem</li>
            <li>Referrer-URL (zuvor besuchte Seite)</li>
          </ul>
          <P>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
            an der Sicherheit und dem Betrieb der Website).<br />
            <strong>Speicherdauer:</strong> Die Logfiles werden nach spätestens 30 Tagen gelöscht.
          </P>
        </Block>

        <Block title="4. Buchungsanfragen / Kontaktformular">
          <P>
            Wenn Sie über unser Buchungsformular eine Anfrage stellen, verarbeiten wir folgende
            Daten zur Bearbeitung Ihrer Anfrage:
          </P>
          <ul style={styles.list}>
            <li>Vor- und Nachname</li>
            <li>Straße, Postleitzahl, Ort</li>
            <li>Telefonnummer</li>
            <li>E-Mail-Adresse</li>
            <li>Reisezeitraum (An- und Abreisedatum)</li>
            <li>Angaben zur Unterkunft und Mitreisenden</li>
            <li>Anmerkungen (freiwillig)</li>
          </ul>
          <P>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung).<br />
            <strong>Speicherdauer:</strong> Die Daten werden nach Abschluss der Buchungsabwicklung
            und Ablauf gesetzlicher Aufbewahrungsfristen (7 Jahre für buchhalterische Unterlagen)
            gelöscht.
          </P>
          <P>
            Die übermittelten Daten werden nicht an Dritte weitergegeben, außer soweit dies zur
            Vertragserfüllung erforderlich ist.
          </P>
        </Block>

        <Block title="5. Schriftarten (Bunny Fonts)">
          <P>
            Diese Website verwendet Schriftarten des Anbieters <strong>Bunny.net</strong> (Bunny Way
            d.o.o., Cesta komandanta Staneta 4a, 1215 Medvode, Slowenien – EU). Beim Laden der
            Schriftarten wird Ihre IP-Adresse an Bunny.net übertragen. Bunny.net ist ein
            europäischer Dienst, der Ihren Datenschutzerklärungen nach DSGVO entspricht und keine
            Daten in Drittländer außerhalb der EU übermittelt.
          </P>
          <P>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
            an einer einheitlichen Darstellung unseres Webangebots).
          </P>
        </Block>

        <Block title="6. Keine Cookies">
          <P>
            Unsere Website verwendet keine Tracking-Cookies oder Analyse-Tools wie Google Analytics.
            Es werden lediglich technisch notwendige Browserspeicher (localStorage) für interne
            Verwaltungsfunktionen genutzt, die ausschließlich für angemeldete Administratoren
            relevant sind und keine personenbezogenen Daten von Besuchern enthalten.
          </P>
        </Block>

        <Block title="7. Ihre Rechte als betroffene Person">
          <P>Gemäß DSGVO haben Sie folgende Rechte gegenüber uns:</P>
          <ul style={styles.list}>
            <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO): Sie können Auskunft über Ihre bei uns gespeicherten Daten verlangen.</li>
            <li><strong>Berichtigungsrecht</strong> (Art. 16 DSGVO): Sie können die Berichtigung unrichtiger Daten verlangen.</li>
            <li><strong>Löschungsrecht</strong> (Art. 17 DSGVO): Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</li>
            <li><strong>Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
            <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
            <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO): Sie können der Verarbeitung Ihrer Daten auf Basis berechtigter Interessen widersprechen.</li>
          </ul>
          <P>
            Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:{' '}
            <a href={`mailto:${OPERATOR_EMAIL}`} style={styles.link}>{OPERATOR_EMAIL}</a>
          </P>
        </Block>

        <Block title="8. Beschwerderecht bei der Datenschutzbehörde">
          <P>
            Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen
            die DSGVO verstößt, haben Sie das Recht, sich bei der österreichischen
            Datenschutzbehörde zu beschweren:
          </P>
          <p style={styles.address}>
            <strong>Österreichische Datenschutzbehörde</strong><br />
            Barichgasse 40–42<br />
            1030 Wien<br />
            Telefon: +43 1 52 152-0<br />
            E-Mail: dsb@dsb.gv.at<br />
            Web:{' '}
            <a
              href="https://www.dsb.gv.at"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              www.dsb.gv.at
            </a>
          </p>
        </Block>

        <Block title="9. Aktualität dieser Datenschutzerklärung">
          <P>
            Diese Datenschutzerklärung ist aktuell gültig und hat den Stand April 2026.
            Durch die Weiterentwicklung unserer Website kann eine Anpassung dieser
            Datenschutzerklärung notwendig werden.
          </P>
        </Block>

      </div>
    </main>
  );
}

function Block({ title, children }) {
  return (
    <section style={styles.block}>
      <h2 style={styles.blockTitle}>{title}</h2>
      <div style={styles.blockContent}>{children}</div>
    </section>
  );
}

function P({ children }) {
  return <p style={styles.bodyText}>{children}</p>;
}

const styles = {
  page: { backgroundColor: 'white', minHeight: '70vh' },

  pageHeader: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e5e7eb',
    padding: '4rem 1.5rem 3.5rem',
    textAlign: 'center',
  },
  pageHeaderInner: { maxWidth: '640px', margin: '0 auto' },
  eyebrow: { fontSize: '0.75rem', fontFamily: F, fontWeight: '600', letterSpacing: '1.8px', textTransform: 'uppercase', color: '#1e8449' },
  heading: { color: '#111827', fontFamily: F, fontSize: 'clamp(1.9rem,5vw,2.8rem)', fontWeight: '700', marginTop: '0.4rem', marginBottom: '0.7rem', letterSpacing: '-0.3px' },
  sub: { color: '#6b7280', fontFamily: F, fontSize: '0.95rem' },

  inner: { maxWidth: '760px', margin: '0 auto', padding: '3rem 1.5rem 5rem' },

  block: { marginBottom: '2.5rem', paddingBottom: '2.5rem', borderBottom: '1px solid #f3f4f6' },
  blockTitle: { color: '#111827', fontFamily: F, fontSize: '1rem', fontWeight: '700', marginBottom: '0.85rem' },
  blockContent: { color: '#374151', fontFamily: F, fontSize: '0.95rem', lineHeight: '1.75' },
  bodyText: { marginBottom: '0.75rem' },
  list: { marginLeft: '1.25rem', marginBottom: '0.75rem', display: 'flex', flexDirection: 'column', gap: '0.35rem' },
  address: { fontStyle: 'normal', lineHeight: '1.9', fontFamily: F, fontSize: '0.95rem', color: '#374151' },
  link: { color: '#1e8449', textDecoration: 'none' },
};
